import React, { useState, useEffect } from 'react';
import ProjectPlaceholder from '../../components/UI/Placeholder/ProjectPlaceholder/ProjectPlaceholder';
import Gallery from '../../components/Gallery/Gallery';
import GalleryItem from '../../components/Gallery/GalleryItem/GalleryItem';
import ShareButton from '../../components/UI/SocialShareButton/SocialShareButton';
import classes from './Project.module.scss';
import { Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import axios from '../../axios-base';
import moment from 'moment';
import SMSVote from './SMSVote';
import FingerprintVote from './FingerprintVote';
import VotePlaceholder from './VotePlaceholder';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { sendVirtualPageView } from '../../shared/utility';
import {
    IconBrandInstagram,
    IconBrandFacebook,
    IconBrandYoutube,
    IconCircleCheck,
    IconShare,
} from '@tabler/icons-react';
import CountUp from 'react-countup';
import NumbersAndBrand from '../ProjectList/NumbersAndBrand/NumbersAndBrand';
import { usePhases } from '../../store/configStore';
import { useProjectPageConfig } from '../../store/designStore';

function Project(props) {
    const votingPhases = usePhases();
    const [loadedPost, setLoadedPost] = useState(null);
    const { contestantAnswerHeaders = [] } = useProjectPageConfig();

    let { id } = useParams();
    useEffect(() => {
        if (id) {
            // @todo : implement Optional chaining for cleaner nested property comparison
            if (!loadedPost || (loadedPost && loadedPost.id !== id)) {
                axios
                    .get(`/projects/${id}`) // leading slash for route is necessary for archival detection!
                    .then(({ data }) => setLoadedPost(data))
                    .catch((error) => {
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            console.log(error.response.data);
                            console.log(error.response.status);
                            console.log(error.response.headers);
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            console.log(error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            }
            sendVirtualPageView(`/${id}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let projectVoteCount = <span className="ps-1">0 Stimmen</span>;
    let voteComponent;

    if (loadedPost && votingPhases) {
        const { appStatus, voteStart } = votingPhases;

        switch (appStatus) {
            case 'SIGNUP':
                let text = 'Am ' + moment(voteStart).format('DD.MM.') + ' können Sie hier abstimmen!';
                voteComponent = <VotePlaceholder text={text} />;
                break;
            case 'QUALIFICATION':
                // In qualification phase, we use FingerprintVote
                voteComponent = <FingerprintVote {...props} />;
                break;
            case 'FINALE':
                if (loadedPost.isFinalist || !votingPhases.hasQualification) {
                    voteComponent = <SMSVote projectCategory={loadedPost.projectCategory} {...props} />;
                } else {
                    voteComponent = <VotePlaceholder text="Leider nicht im Finale" />;
                }
                break;
            case 'CLOSED':
            default:
                voteComponent = <VotePlaceholder text="Abstimmung ist beendet!" />;
                break;
        }

        const isFinale = appStatus === 'FINALE' || (appStatus === 'CLOSED' && votingPhases.hasFinale);
        if (isFinale) {
            if (loadedPost.voteCountFinale && (loadedPost.isFinalist || !votingPhases.hasQualification)) {
                projectVoteCount = (
                    <CountUp
                        className="ps-1"
                        end={loadedPost.voteCountFinale}
                        decimal=","
                        separator="."
                        suffix=" Stimmen"
                    />
                );
            }
        } else {
            if (loadedPost.voteCount) {
                projectVoteCount = (
                    <CountUp className="ps-1" end={loadedPost.voteCount} decimal="," separator="." suffix=" Stimmen" />
                );
            }
        }
    }

    let project = (
        <Row className="py-3">
            <Col xs="12">
                <ProjectPlaceholder />
            </Col>
        </Row>
    );

    if (loadedPost) {
        const activeAnswers = [];
        contestantAnswerHeaders.forEach((header, idx) => {
            const answerKey = `contestantAnswer${idx + 1}`;
            const answerValue = loadedPost[answerKey];
            if (header && header.trim() !== '' && answerValue && answerValue.trim() !== '') {
                activeAnswers.push({
                    header: header.trim(),
                    text: answerValue.trim(),
                });
            }
        });
        const activeAnswersCount = activeAnswers.length;

        // move socialMediaServices configuration to database so services can eventually be setup per campaign via Cockpit
        const socialMediaServices = [
            'whatsApp',
            'instagram',
            'facebook',
            'facebookMessenger',
            'pinterest',
            'telegram',
            'email',
            'bluesky',
            'linkedin',
            'xing',
        ];
        project = (
            <>
                <Helmet>
                    <title>{`${loadedPost.contestantName} | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
                </Helmet>
                <Row className="my-3">
                    <Col xs="12" lg="5">
                        <NumbersAndBrand />
                        <Row className="mb-3">
                            <Col className="text-start">
                                <h3 className="mb-0">{loadedPost.contestantName}</h3>
                                <p className="my-0">{loadedPost.projectTitle}</p>
                                <p className="mb-0 text-primary">
                                    <IconCircleCheck size={20} className="me-1" />
                                    {projectVoteCount}
                                </p>
                                {/*
                                {loadedPost.projectCategory ?
                                < p className="mb-0 text-primary">
                                    <IconTag
                                        size={20}
                                        className="pe-1" />
                                    {loadedPost.projectCategory}
                                    </p>
                                : null}
*/}
                            </Col>
                        </Row>
                        <Row className="mb-1">{voteComponent}</Row>
                        <Row className="mb-3">
                            <Col xs="12" lg="12">
                                <UncontrolledDropdown direction="down" className="d-grid">
                                    <DropdownToggle color="primary" outline>
                                        Mehr Stimmen sammeln? Jetzt teilen!
                                        <IconShare className="ps-1" size={20} />
                                    </DropdownToggle>
                                    <DropdownMenu
                                        end
                                        className="mt-1 p-0"
                                        style={{ boxShadow: '0 3px 4px 0px rgb(0 0 0 / 25%)' }}
                                    >
                                        <Row>
                                            {socialMediaServices.map((service, index) => {
                                                return (
                                                    <Col
                                                        xs="6"
                                                        key={index}
                                                        className={`${classes.DropdownItemContainer}`}
                                                    >
                                                        <DropdownItem className="btn-light btn" toggle={false}>
                                                            <ShareButton
                                                                shareType={service}
                                                                shareTitle={loadedPost.contestantName}
                                                            />
                                                        </DropdownItem>
                                                        <DropdownItem divider className="m-0" />
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </Col>
                        </Row>
                    </Col>

                    <Col xs="12" lg="7">
                        <Row>
                            {activeAnswers.map((answer, i) => (
                                <Col xs={{ size: 12, order: i + 2 }} lg={{ order: i + 1 }} key={i}>
                                    <h1 className="text-primary">{answer.header}</h1>
                                    <p>{answer.text}</p>
                                </Col>
                            ))}

                            <Col xs={{ size: 12, order: 1 }} lg={{ order: activeAnswersCount + 1 }} className="px-0">
                                <Gallery>
                                    {loadedPost.projectGallery.map((galleryItem, index) => (
                                        <GalleryItem key={index} src={galleryItem.url} alt={galleryItem.alt} />
                                    ))}
                                </Gallery>
                            </Col>
                            <Col
                                xs={{ size: 12, order: activeAnswersCount + 2 }}
                                lg={{ order: activeAnswersCount + 2 }}
                            >
                                {loadedPost.contestantInstagramProfile ||
                                loadedPost.contestantFacebookProfile ||
                                loadedPost.contestantYouTubeChannel ? (
                                    <h3 className="text-primary">
                                        Jetzt dieses Profil auch auf Social Media erkunden:
                                    </h3>
                                ) : null}
                                <div className="d-flex flex-wrap">
                                    {loadedPost.contestantInstagramProfile ? (
                                        <a
                                            className="btn btn-light rounded-5 me-2 mb-2 d-flex align-items-center anl_project--instagram-profile-lnk"
                                            href={loadedPost.contestantInstagramProfile}
                                            target="_blank"
                                            rel="noopener nofollow"
                                        >
                                            <IconBrandInstagram
                                                className="me-2"
                                                style={{ color: '#C13584' }}
                                                size={20}
                                            />
                                            Instagram
                                        </a>
                                    ) : null}
                                    {loadedPost.contestantFacebookProfile ? (
                                        <a
                                            className="btn btn-light rounded-5 me-2 mb-2 d-flex align-items-center anl_project--facebook-profile-lnk"
                                            href={loadedPost.contestantFacebookProfile}
                                            target="_blank"
                                            rel="noopener nofollow"
                                        >
                                            <IconBrandFacebook
                                                className="me-2"
                                                style={{ color: '#1877F2' }}
                                                size={20}
                                            />
                                            Facebook
                                        </a>
                                    ) : null}
                                    {loadedPost.contestantYouTubeChannel ? (
                                        <a
                                            className="btn btn-light rounded-5 me-2 mb-2 d-flex align-items-center anl_project--youtube-profile-lnk"
                                            href={loadedPost.contestantYouTubeChannel}
                                            target="_blank"
                                            rel="noopener nofollow"
                                        >
                                            <IconBrandYoutube className="me-2" style={{ color: '#FF0000' }} size={20} />
                                            YouTube
                                        </a>
                                    ) : null}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        );
    }

    return <>{project}</>;
}

export default Project;
